import { render, staticRenderFns } from "./modal-discard.vue?vue&type=template&id=b94ba4ce"
import script from "./modal-discard.vue?vue&type=script&lang=js"
export * from "./modal-discard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports